// import {getList} from '@/api/base_request'


export default {
  'entityName': 'user',
  "title": "User",
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [
   
  {
      slim:true,
      value: 'protocol_id',
      text: 'Protocol',
      title:"name",
      'type': 'autocomplete',
      'table': {
        'sortable': true,
        'filter': true
      },
      readonly:true,
      filter: (item, search) => {
        if (search) return [{'protocol.name': `%${search}%`}]
      },
      render : (v) => {
        return v.protocol.name
      },
      'validators': [
        'required',
      ]
    },
   
    {
      slim:true,
      value: 'protocol_roles_id',
      // reference:'protocol_roles',
      text: 'User profile',
      title: "name",
      id:'id',
      subtitle: item => `${item.group}`,
      'type': 'text',      
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required'
      ],
      render: item => `${item.protocol_roles.name}`,
      filter: (item, search) => { return { 'protocol_roles.name': `%${search}%` } },
    },
    {
      slim: true,
      value: 'username',
      text: 'Username',
      'type': 'text',   
      'validators': [
        'required',
      ],
      'table': {
        'sortable': true,
        'filter': true
      },
    },
    {
      slim: true,
      value: 'email',
      text: 'Email',
      'table': {
        'sortable': true,
        'filter': true
      },
      'type': 'text',
      'validators': [
        'required',
        //ISSUE 266
        'email',
        'emaillen'
        //ISSUE 266
      ]
    },
    {
      slim: true,
      value: 'sites',
      text: 'Sites',
      render: item => { return item.sites && item.sites[0] ? item.sites[0]['code'] + ' ' +  (item.sites.length-1 ? ('(+' + (item.sites.length-1)) + ')' : '') : ''} ,
      tooltip: item => {return item.sites && item.sites[0] ? item.sites[0]['factor_label'] : ''},
      'table': {
        'sortable': true,
        'filter': true
      },
      'type': 'text',
    },
    {
      slim:true,
      value: 'phone',
      text: 'Phone',
      type: 'text',
      default: null,
      validators: [ 
      //  'required'        
      ],
    },

    {
      value: "platforms",
      text: "Platforms",
      append_icon: '',
      multiple: true,
      chips: true,
      deletable_chips:true,
      items:['REDCap', 'eCDS', 'SafetyDB'],
      placeholder: '',
      loadRemote: false,
      type: "combobox",
      'table': {
        'sortable': true,
        'filter': true
      },
      render: (item) => { return item.platforms && item.platforms.join(' ') },
    },

    {
      slim:true,
      value: 'status',
      text: 'Status',
      'type': 'list',
      'table': {
        'sortable': true,
        'filter': true
      },
      'list': [
        'New',
        'To Activate',
        'Active',
        'Removed'
      ],
      'validators': [
        'required'
      ]
    },

    {
      value: 'sites',
      text: 'Sites',
      title:"factor_label",
      multiple:true,
      loadRemote:false,
      chips:true,
      items:[],
      id:'id',
      'type': 'combobox',
      // render : (v) => {
      //   return v.factor_label
      // },
      'validators': [
        'required',
      ]
    },

  ],
  actions: [
    { "value": "view", "text": "View", "icon": "mdi-eye", "color": "primary" },
    { "value": "edit", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
    { "value": "remove_logic", "text": "Remove logic", "icon": "mdi-delete", "color": "primary", disable: (item) => { return item.status && (item.status == 'Removed' || item.status == 'New' || item.status == 'To Activate' )} },
    { "value": "remove", "text": "Remove physic", "icon": "mdi-delete-forever", "color": "primary", disable: (item) => { return item.status && (item.status == 'Removed' || (item.status != 'New' && item.status != 'To Activate'))} }, "audit_trail"
  ]
}
